import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
} from '@angular/core'
import { Subscription } from 'rxjs'
import { MagliveApiClient } from 'src/lib/api-client/maglive-api-client'
import { ConsoleLogger } from 'src/lib/console-logger'
import { ChangePageRequest, GiftPointHistory } from 'src/lib/entity/gift-point'

@Component({
  selector: 'maglive-point-history-detail',
  templateUrl: './point-history-detail.component.html',
  styleUrls: ['./point-history-detail.component.scss'],
})
export class PointHistoryDetailComponent implements OnInit, OnDestroy {
  @Input() yearMonth: string
  @Output() changePageEvent = new EventEmitter<ChangePageRequest>()

  /* Subscription */
  private getGiftPointHistoriesSub: Subscription | undefined

  pointHistoryForMonth: GiftPointHistory[] | 'NOT_FOUND'

  constructor(private logger: ConsoleLogger) {}

  ngOnInit(): void {
    let [year, month] = this.yearMonth.split('年 ')
    month = month.split('月')[0]

    this.getGiftPointHistoriesSub = MagliveApiClient.getGiftPointHistories(
      Number(year) + '-' + Number(month)
    ).subscribe((value) => {
      this.pointHistoryForMonth = value
      this.logger.info(
        this.constructor.name,
        'getGiftPointHistories',
        'pointHistoryForMonth',
        value
      )
    })

    // ロールバック対策
    // history.pushState(null, null, location.href)
    // window.addEventListener('popstate', this.browserBack)
  }

  ngOnDestroy() {
    // window.removeEventListener('popstate', this.browserBack)
    if (this.getGiftPointHistoriesSub) {
      this.getGiftPointHistoriesSub.unsubscribe()
    }
  }

  /**
   * ブラウザバック押下時の挙動。同期遷移させない。
   */
  // private browserBack = (e) => {
  //   e.preventDefault()
  //   history.go(1)
  //   this.changePageEvent.emit({name: 'HISTORY_ALL'})
  //   console.log('detail')
  //   e.stopImmediatePropagation()
  // }
}
